<p-dialog
  [style]="viewStyleObject()"
  [contentStyle]="contentStyleObject()"
  [(visible)]="display"
  [modal]="true"
  [closable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
  [baseZIndex]="10000"
  appendTo="body">

  <p-header>
    {{ name }}
  </p-header>

  <div *ngIf="isLoading" class="viewer-state-container">
    <div class="state-content">
      <p class="icon">&#9203;</p>
      <p>Loading file...</p>
    </div>
  </div>

  <div *ngIf="isPdf && !isLoading && !hasError" class="iframe-container" style="height: 100%;">
    <ngx-extended-pdf-viewer
      [src]="objectUrl"
      [height]="'100%'"
      [showToolbar]="true"
      [showSidebarButton]="true"
      [sidebarVisible]="false"
      [activeSidebarView]="1"
      [zoom]="'auto'"
      [filenameForDownload]="getFileName()"
      [showOpenFileButton]="false"
      [showWrappedScrollButton]="false"
      [showInfiniteScrollButton]="false"
      [showBookModeButton]="false"
      [showSinglePageModeButton]="false"
      [showVerticalScrollButton]="false"
      [showHorizontalScrollButton]="false"
      [showSpreadButton]="false"
      [showPropertiesButton]="false"
      [showFindButton]="true"
      [showDownloadButton]="true"
      [textLayer]="true"
      (pdfLoaded)="onIframeLoad()"
      (pdfLoadingFailed)="onIframeError()">
    </ngx-extended-pdf-viewer>
  </div>

  <div *ngIf="hasError && !isLoading" class="viewer-state-container">
    <div class="state-content error-content">
      <p class="icon">&#9888;</p>
      <p>Preview not available</p>
      <a [href]="objectUrl"
         [download]="getFileName()"
         class="download-button">
        Download File
      </a>
    </div>
  </div>

<div *ngIf="!isPdf && !isLoading && !hasError" class="custom-viewer-wrapper">
    
    <div class="content-display-area">
        
        <div *ngIf="sheetNames.length > 0" class="spreadsheet-grid-container">
            <div class="grid-pane corner-pane"></div>
            
            <div #colHeaderPane class="grid-pane col-header-pane"></div>
            
            <div #rowHeaderPane class="grid-pane row-header-pane"></div>

            <div #contentPane (scroll)="onContentScroll()" class="grid-pane main-content-pane">
                <div #mainContent id="attchcontainer"></div>
            </div>
        </div>

        <div *ngIf="sheetNames.length === 0" id="attchcontainer" #attchcontainer></div>
    </div>

    <div *ngIf="sheetNames.length > 0" class="sheet-selector-footer">
        <ul>
          <li *ngFor="let sheet of sheetNames"
              [ngClass]="{'active': sheet === activeSheetName}">
              
              <button type="button" class="sheet-button" (click)="selectSheet(sheet)">
                  {{ sheet }}
              </button>

          </li>
        </ul>
    </div>
</div>

</p-dialog>